import { FixQueueRow } from './FixQueueRow.jsx';

/**
 * Fix Queue panel — renders the engine-emitted topIssues array in rank
 * order. The engine is the source of truth; this component does not
 * re-rank, invent severities, or fabricate figures.
 */
export function FixQueue({ topIssues }) {
  const issues = Array.isArray(topIssues) ? topIssues : [];
  if (issues.length === 0) {
    return (
      <div className="fix-queue-empty" role="status">
        <p>No open fix-queue items. The schedule passes all gating checks.</p>
      </div>
    );
  }
  return (
    <section className="fix-queue" aria-label="Priority fix queue">
      <header className="fix-queue-header">
        <h2 className="fix-queue-title">Fix Queue — Start Here</h2>
        <p className="fix-queue-sub">
          {issues.length} priority {issues.length === 1 ? 'issue' : 'issues'} ranked by schedule impact
        </p>
      </header>
      <div className="fix-queue-list">
        {issues.map((issue) => (
          <FixQueueRow key={`${issue.rank}-${issue.checkNumber}`} issue={issue} />
        ))}
      </div>
    </section>
  );
}
